import { render, staticRenderFns } from "./bulkModal.vue?vue&type=template&id=41c36544&scoped=true&"
import script from "./bulkModal.vue?vue&type=script&lang=js&"
export * from "./bulkModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c36544",
  null
  
)

export default component.exports